import { doc, updateDoc } from 'firebase/firestore';
import { firestore } from '~/firebase/init';
import { PlatformCart } from '~/types/cart';

export default async function updateGroupCart(
  platformId: string,
  cartId: string,
  data: Partial<PlatformCart>,
) {
  const ref = doc(firestore, 'platforms', platformId, 'carts', cartId);

  await updateDoc(ref, data);
}
